export function getFullName(
    user?: {
        firstName?: string | null;
        lastName?: string | null;
        first_name?: string | null;
        last_name?: string | null;
    } | null
) {
    return [user?.firstName || user?.first_name, user?.lastName || user?.last_name].filter(el => el).join(' ');
}
